import { styled } from '@mui/material/styles';
import MuiRadio, { RadioProps } from '@mui/material/Radio';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 20,
  height: 20,
  boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
  backgroundColor: '#fff',
  'input:disabled ~ &': {
    opacity: 0.5,
  },
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: '#fff',
  '&:before': {
    display: 'block',
    width: 38,
    height: 38,
    margin: -9,
    backgroundImage: `radial-gradient(${theme.palette.primary.main},${theme.palette.primary.main} 28%,transparent 32%)`,
    content: '""',
  },
}));

export const Radio = (props: RadioProps) => {
  return <MuiRadio color="primary" checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />;
};
